import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ItemsProvider } from './contexts/ItemsContext';
import { UserProvider } from './contexts/UserContext';
import NavBar from './components/NavBar';
import Home from './pages/Home';
import Branding from './pages/Branding';
import Programs from './pages/Programs';
import Profile from './pages/Profile';
import ItemDetail from './pages/ItemDetail';
import ProfileCart from './pages/profile/Cart';
import ProfileCheckout from './pages/profile/Checkout';
import ProfileFavorites from './pages/profile/Favorites';
import ProfileHistory from './pages/profile/History';
import ProfileCoupons from './pages/profile/Coupons';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure';
import Blog from './pages/Blog';
import ContactUs from './components/ContactUs';

function App() {
  return (
    <UserProvider>
      <ItemsProvider>
        <Router>
        <div className="App">
          <NavBar />
          <main style={{ padding: 20 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/branding" element={<Branding />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/item/:id" element={<ItemDetail />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/profile/cart" element={<ProfileCart />} />
              <Route path="/profile/checkout" element={<ProfileCheckout />} />
              <Route path="/profile/favorites" element={<ProfileFavorites />} />
              <Route path="/profile/history" element={<ProfileHistory />} />
              <Route path="/profile/coupons" element={<ProfileCoupons />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/payment-failure" element={<PaymentFailure />} />
              <Route path="/contactus" element={<ContactUs />} />
            </Routes>
          </main>
        </div>
        </Router>
      </ItemsProvider>
    </UserProvider>
  );
}

export default App;
